import { getAlertLevel } from "./alarms";

const getOnlineStatus = (device) => {
  if (!device) return "Offline";

  const severity = getAlertLevel("network", device);
  if (severity === "normal") return "Online";
  return "Offline";
};

const wifiStatusText = (device, t) => {
  const severity = getAlertLevel("wifi", device);
  if (severity == "normal") return t("stateAlarms.powerSupply.connected");

  return "-";
};

const powerSupplyStatusText = (device, t) => {
  if (device.stateAlarms && device.stateAlarms.device_state.power.power_supply === "disconnected") {
    return t("stateAlarms.powerSupply.disconnected");
  }
  if (device.stateAlarms && device.stateAlarms.device_state.power.power_supply === "connected") {
    return t("stateAlarms.powerSupply.connected");
  }

  return "-";
};

const braceletPresenceStatusText = (device, t) => {
  const severity = getAlertLevel("accessories", device);

  if (severity === "normal") return t("stateAlarms.braceletPresence.inRange");
  if (severity === "unknown") return t("stateAlarms.braceletPresence.unknown");

  return "-";
};

const dailyCheckInStatusText = (device, t) => {
  if (!device.isOnline) {
    return "-";
  }
  if (device.states.dailyCheckIn === "active") {
    return t("stateAlarms.dailyCheckIn.active");
  }
  if (device.states.dailyCheckIn === "paused_by_device") {
    return t("stateAlarms.dailyCheckIn.pausedByDevice");
  }
  if (device.states.dailyCheckIn === "paused_by_platform") {
    return t("stateAlarms.dailyCheckIn.pausedByPlatform");
  }
  if (device.states.dailyCheckIn === "missing") {
    return t("stateAlarms.dailyCheckIn.missing");
  }
  return "-";
};

export { dailyCheckInStatusText, wifiStatusText, getOnlineStatus, powerSupplyStatusText, braceletPresenceStatusText };
